/**
 * Return asset URL
 *
 * @param path
 */
export const asset = (path): string => {
  return `${process.env.REACT_APP_IMAGE_PREFIX}${path}`
}
